module.exports = __webpack_public_path__ + "08ab026aa1f0c0ac41ac5b205985233e.pdf";